import { render, staticRenderFns } from "./signetInfo.vue?vue&type=template&id=1d9a1048&scoped=true"
import script from "./signetInfo.vue?vue&type=script&lang=js"
export * from "./signetInfo.vue?vue&type=script&lang=js"
import style0 from "./signetInfo.vue?vue&type=style&index=0&id=1d9a1048&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a1048",
  null
  
)

export default component.exports